import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '32px'
  },
  button: {
    marginTop: '10px',
    fontWeight: 'bold'
  },
  clearAllButton: {
    marginTop: '10px'
  },
  buttonPosition: {
    textAlign: 'end'
  }
}));
